export default __webpack_public_path__ + "static/B0317-1d8fbb48cd784d9256a3c6d11d5dedbc.png";